import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SelectLeistungPage } from './select-leistung';

@NgModule({
  declarations: [
    SelectLeistungPage,
  ],
  imports: [
    IonicPageModule.forChild(SelectLeistungPage),
  ],
})
export class SelectLeistungPageModule {}



// WEBPACK FOOTER //
// ./src/pages/select-leistung/select-leistung.module.ts